import { List, ListItem } from "@mui/material";
import { Dognhvileplass } from "../../services/RuteplanAPI";
import { IRoutePartProps } from "./RouteDescription";
import dognhvileplassIconSource from "../../assets/restingarea24hrs-marker.svg"

export default function Dognhvileplasser (props: IRoutePartProps) {
    
    return (      
        <>
            { props.roadFeatures && props.roadFeatures.dognhvileplasser && props.roadFeatures.dognhvileplasser.length > 0 &&
            <List>
                {props.roadFeatures.dognhvileplasser.map( (dognhvileplass: Dognhvileplass, index: number) => (
                    <ListItem 
                        key={dognhvileplass.navn + index} 
                        className="roadFeature" 
                        onClick={(event) => {props.onClick(dognhvileplass, event)}}
                        onMouseEnter={() => { props.onMouseEnterItem(dognhvileplass)}}
                        onMouseLeave={props.onMouseLeaveItem}> 
                        <img src={dognhvileplassIconSource} height="24" style={{paddingRight:"5px"}} alt="Dognhvileplass icon" title="dognhvileplassIcon"/>
                        {dognhvileplass.navn}
                    </ListItem>
                ))}
            </List>        
            }
        </>  
    )

}